import {RouterProvider} from 'react-router-dom';
import {Toaster} from 'sonner';
import {router} from '@/router';

export default function App() {
  return (
    <div className="h-full w-full bg-[#010009]">
      <RouterProvider router={router} />
      <Toaster
        position="bottom-center"
        theme="dark"
        toastOptions={{
          style: {
            background: '#16151A',
            border: '1px solid rgba(255,255,255,0.07)',
            color: '#FAFAF9'
          }
        }}
      />
    </div>
  );
}
